<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/ui/VSelect.vue";
import customerTypesApi from "../api/resources/customerTypesApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],

  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getOptions() {
      customerTypesApi.index().then((response) => {
        this.options = response.data.map((type) => {
          return { text: type.label, value: type.id };
        });
      });
    },
  },

  created() {
    this.getOptions();
  },
};
</script>

<style></style>
